import { render, staticRenderFns } from "./CRLoading.vue?vue&type=template&id=fc439de8&scoped=true"
import script from "./CRLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./CRLoading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRLoading.vue?vue&type=style&index=0&id=fc439de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc439de8",
  null
  
)

export default component.exports